function filterMeteredProducts(products) {
    return products?.filter((product)=>!product.isLicensed) ?? [];
}
export { filterMeteredProducts };
